import clsx from 'clsx'

import s from './Button.module.scss'
import type { ButtonProps } from './Button.props'

export function Button({ children, className, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(s.button, className)}
      type="button"
      {...props}
    >
      {children}
    </button>
  )
}
